var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "TcLoginDni h-full" }, [
    _vm.loading
      ? _c(
          "div",
          {
            staticClass:
              "container px-5 mx-auto flex flex-col items-center justify-center gap-5 h-full pb-5"
          },
          [
            _c("h2", { staticClass: "text-2xl" }, [
              _vm._v("Intentando conectar con el servicio de lector del DNIe")
            ]),
            _vm._v(" "),
            _c("h3", [_vm._v("Por favor espere...")]),
            _vm._v(" "),
            _c("TcIcon", {
              staticClass: "h-6 w-6 animate-spin",
              attrs: { icon: "hourglass" }
            })
          ],
          1
        )
      : _c(
          "div",
          {
            staticClass:
              "container px-5 mx-auto flex flex-col items-center justify-center gap-5 h-full pb-5"
          },
          [
            _vm.grant
              ? [
                  _c("h2", { staticClass: "text-2xl" }, [_vm._v("DNI Válido")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Tratando de validar al usuario")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Por favor espere...")]),
                  _vm._v(" "),
                  _c("TcIcon", {
                    staticClass: "h-6 w-6 animate-spin",
                    attrs: { icon: "hourglass" }
                  })
                ]
              : [
                  _c("h2", { staticClass: "text-2xl" }, [
                    _vm._v("DNI inválido")
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.msg))]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Por favor compruebe que el DNIe se encuentra dentro del lector e inténtelo de nuevo"
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "mt-5 mb-3",
                      staticStyle: { width: "300px" },
                      on: { click: _vm.goDni }
                    },
                    [_vm._v("Validar DNIe")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-secondary",
                      staticStyle: { width: "300px" },
                      on: { click: _vm.goWelcome }
                    },
                    [_vm._v("Volver al inicio")]
                  )
                ]
          ],
          2
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }